<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Добавить преподавателя</h4>
            </div>
            <div class="card-body">

              <div v-if="successMessage" class="alert alert-success">
                <span>{{ successMessage }}</span>
                <button type="button" class="close" @click="successMessage = null">×</button>
              </div>

              <div v-if="errorMessage" class="alert alert-danger">
                <span>{{ errorMessage }}</span>
                <button type="button" class="close" @click="errorMessage = null">×</button>
              </div>

              <form @submit.prevent="createTutor">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>ФИО Преподавателя</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Например: Abdurahmon"
                        v-model="tutorName"
                        required
                      >
                    </div>
                  </div>

                  <div class="col-md-4 d-flex align-items-end">
                    <button type="submit" class="btn btn-info btn-fill btn-block mb-3" :disabled="loading">
                      {{ loading ? 'Загрузка...' : 'Добавить' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">

            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <h4 class="card-title">Список преподавателей</h4>
                <p class="category">Все доступные преподаватели</p>
              </div>

              <div class="pagination-controls" v-if="tutors.length > 0 || pageIndex > 1">
                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="pageIndex === 1 || fetching"
                   @click="changePage(-1)"
                 >
                   <i class="fa fa-chevron-left"></i> Назад
                 </button>

                 <span class="mx-3 font-weight-bold">Стр. {{ pageIndex }}</span>

                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="isLastPage || fetching"
                   @click="changePage(1)"
                 >
                   Вперед <i class="fa fa-chevron-right"></i>
                 </button>
              </div>
            </div>

            <div class="card-body table-full-width table-responsive">
              <table class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Имя</th>
                    <th>Дата создания</th>
                    <th class="text-right">Действия</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="fetching">
                    <td colspan="4" class="text-center">Загрузка списка...</td>
                  </tr>
                  <tr v-if="tutors.length === 0 && !fetching">
                    <td colspan="4" class="text-center">Список пуст</td>
                  </tr>
                  <tr v-for="(tutor, index) in tutors" :key="tutor.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ tutor.name }}</td>
                    <td>{{ formatDate(tutor.createdAt) }}</td>
                    <td class="text-right">
                      <button
                        class="btn btn-danger btn-sm btn-fill"
                        @click="deleteTutor(tutor.id)"
                        title="Удалить"
                      >
                        <i class="fa fa-trash"></i> Удалить
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-muted small p-3" v-if="tutors.length > 0">
                 Показано {{ tutors.length }} записей (Лимит: {{ pageSize }})
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// ✅ IMPORT API_URL HERE
import { API_URL } from '../server';

export default {
  name: 'CreateTutor',
  data() {
    return {
      // Create Form Data
      tutorName: '',
      loading: false,

      // List Data
      tutors: [],
      fetching: false,

      // Pagination Data
      pageIndex: 1,
      pageSize: 50,
      isLastPage: false,

      // Messages
      errorMessage: null,
      successMessage: null,
    };
  },
  mounted() {
    this.fetchTutors();
  },
  methods: {
    // 1. GET ALL TUTORS (With Pagination)
    async fetchTutors() {
      this.fetching = true;
      const token = localStorage.getItem('token');

      try {
        // ✅ USE API_URL + Endpoint + Params
        const response = await axios.get(
          API_URL + '/api/tutor',
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`
            },
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize
            }
          }
        );

        if (response.data && response.data.code === 200) {
          const data = response.data.data || [];
          this.tutors = data;
          // Determine if we are on the last page based on array size
          this.isLastPage = data.length < this.pageSize;
        } else {
          this.tutors = [];
        }
      } catch (error) {
        console.error('Error fetching tutors:', error);
      } finally {
        this.fetching = false;
      }
    },

    // 2. Change Page
    changePage(direction) {
      this.pageIndex += direction;
      this.fetchTutors();
    },

    // 3. CREATE TUTOR
    async createTutor() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;

      const token = localStorage.getItem('token');

      if (!token) {
        this.errorMessage = 'Ошибка авторизации.';
        this.loading = false;
        return;
      }

      try {
        const payload = {
          name: this.tutorName
        };

        // ✅ USE API_URL + Endpoint
        const response = await axios.post(
          API_URL + '/api/tutor',
          payload,
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data && response.data.code === 200) {
          this.successMessage = `Преподаватель "${this.tutorName}" успешно добавлен!`;
          this.tutorName = '';
          // Reset to page 1 to see the new item
          this.pageIndex = 1;
          this.fetchTutors();
        } else {
          this.errorMessage = 'Не удалось добавить преподавателя.';
        }

      } catch (error) {
        console.error('Create Error:', error);
        if (error.response && error.response.status === 401) {
           this.errorMessage = 'Сессия истекла.';
        } else {
           this.errorMessage = 'Ошибка сервера при добавлении.';
        }
      } finally {
        this.loading = false;
      }
    },

    // 4. DELETE TUTOR
    async deleteTutor(id) {
      if (!confirm('Вы уверены, что хотите удалить этого преподавателя?')) return;

      const token = localStorage.getItem('token');

      try {
        // ✅ USE API_URL + Endpoint
        const response = await axios.delete(
          API_URL + `/api/tutor/${id}`,
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`
            }
          }
        );

        if (response.data && (response.data.code === 200 || response.status === 200)) {
           this.successMessage = 'Преподаватель успешно удален.';
           this.fetchTutors(); // Refresh current page
        } else {
           this.errorMessage = 'Не удалось удалить преподавателя (API вернул ошибку).';
        }

      } catch (error) {
        console.error('Delete Error:', error);
        this.errorMessage = 'Ошибка при удалении преподавателя.';
      }
    },

    // Helper for date formatting
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleString('ru-RU');
    }
  }
};
</script>

<style scoped>
.mb-3 { margin-bottom: 1rem; }
.btn-block { width: 100%; display: block; }
.close { float: right; font-size: 1.5rem; font-weight: 700; line-height: 1; color: #000; text-shadow: 0 1px 0 #fff; opacity: .5; background: transparent; border: 0; cursor: pointer;}
.pagination-controls { display: flex; align-items: center; }
.mx-3 { margin-left: 1rem; margin-right: 1rem; }
</style>
